exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".audit-table th[data-v-53194019], .audit-table td[data-v-53194019] {\n  padding: 0.3rem;\n  font-size: 12px;\n}\n.audit-summary[data-v-53194019] {\n  font-size: 12px;\n  margin: 0px;\n}\n.audit-description-column[data-v-53194019] {\n  min-width: 200px;\n  width: 100%;\n}\n.el-date-editor .el-range-separator[data-v-53194019] {\n  width: 30px !important;\n}\n.el-range-editor.el-input__inner[data-v-53194019] {\n  padding: 1px 10px;\n}\n.el-input__inner[data-v-53194019] {\n  height: 36px;\n  line-height: 36px;\n}\n.audit-tags[data-v-53194019] {\n}\n\n", ""]);

// exports
